// extracted by mini-css-extract-plugin
export default {"icon":"ColumnIcon_icon__pFMh-"};